<template>
  <div>
    <div v-if="isMobile">
      <app-history
        v-for="index in history.length"
        :key="index"
        :index="index - 1"
        :item="history[index - 1]"
        :selectedItem="selectedItem"
        @clicked="onClickItem"
        @removeRequest="removeRequest"
      >
      </app-history>
    </div>
    <div v-else>
      <v-data-table
        :items="history"
        item-key="RequestID"
        :headers="historyHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        show-expand
      >
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn
            class="grid"
            v-if="item.Removable"
            color="red white--text"
            rounded
            @click="removeRequest(item.RequestID)"
          >
            حذف درخواست
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>پاسخ مدرسه: </b>{{ item.StateSchool }}
            <br />
            <br />
            <b>پاسخ مرکز: </b>{{ item.StateCenter }}
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./HistoryCard.vue";
import Dialog from "@/components/Dialog";
import { removeKhoroojRequest } from "@/api/khorooj";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,

      historyHeaders: [
        {
          text: "وضعیت",
          value: "State",
          width: "15%",
        },
        {
          text: "شماره درخواست",
          value: "RequestID",
          width: "15%",
        },
        {
          text: "کشور مقصد",
          value: "Country",
          width: "10%",
        },
        {
          text: "تاریخ شروع",
          value: "AzTarikh",
          width: "15%",
        },
        {
          text: "تاریخ پایان",
          value: "TaTarikh",
          width: "15%",
        },
        /* {
          text: "پاسخ مدرسه",
          value: "StateSchool",
          width: "20%",
        },
        {
          text: "پاسخ مرکز",
          value: "StateCenter",
          width: "22%",
        },*/
        {
          text: "",
          value: "Removable",
          width: "25%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.$store.dispatch("getKhoroojHistory").then(() => {
      for (var i = 0; i < this.history.length; i++) {
        if (this.history[i].Removable) {
          this.selectedItem = i;
          break;
        }
      }
    });
  },
  computed: {
    history() {
      return this.$store.getters.khoroojHistory;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    /**
     * expand khorooj
     */
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeKhoroojRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            
            if (data.Success) {
              this.$store.dispatch("getKhoroojHistory").then(() => {
                for (var i = 0; i < this.history.length; i++) {
                  if (this.history[i].Removable) {
                    this.selectedItem = i;
                    break;
                  }
                }
              });
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
            
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
